import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import { IGroupModel } from '@src/slide/domain/ui-model/element-modeles/Interface/group-model.interface';
import { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';
import { getMenuValues } from '@src/slide/application/service/menu-manager/menu-values';

/**
 * 判断multiply-model/group-model的子元素是否包含某个属性，如effect
 */
export const checkChildModelHasProperty = (selectedModel: IBaseModel, propertyType: string): boolean => {
    let childModels: IBaseModel[] = [];
    if (selectedModel.type === UIModelType.MULTIPLY) {
        childModels = (selectedModel as IMultiplyModel).selectedModels;
    } else if (selectedModel.type === UIModelType.GROUP) {
        childModels = (selectedModel as IGroupModel).children;
    } else {
        return false;
    }
    const { length } = childModels;
    for (let index = 0; index < length; index++) {
        const element = childModels[index];
        if ([UIModelType.MULTIPLY, UIModelType.GROUP].includes(element.type)) {
            return checkChildModelHasProperty(element, propertyType);
        }
        if (getMenuValues(element)[propertyType]) {
            return true;
        }
    }
    return false;
};

/**
 * 判断multiply-model/group-model的子元素是否包含某个类型元素
 */
export const checkChildModelHasSomeTypeElement = (selectedModel: IBaseModel, type: UIModelType): boolean => {
    let childModels: IBaseModel[] = [];
    if (selectedModel.type === UIModelType.MULTIPLY) {
        childModels = (selectedModel as IMultiplyModel).selectedModels;
    } else if (selectedModel.type === UIModelType.GROUP) {
        childModels = (selectedModel as IGroupModel).children;
    } else {
        return false;
    }
    const { length } = childModels;
    for (let index = 0; index < length; index++) {
        const element = childModels[index];
        if ([UIModelType.MULTIPLY, UIModelType.GROUP].includes(element.type)) {
            return checkChildModelHasProperty(element, type);
        }
        if (element.type === type) {
            return true;
        }
    }
    return false;
};

export const checkChildModelSomeWith = (selectedModel: IBaseModel, callback: (model) => boolean): boolean => {
    let childModels: IBaseModel[] = [];
    if (selectedModel.type === UIModelType.MULTIPLY) {
        childModels = (selectedModel as IMultiplyModel).selectedModels;
    } else if (selectedModel.type === UIModelType.GROUP) {
        childModels = (selectedModel as IGroupModel).children;
    } else {
        return false;
    }
    const { length } = childModels;
    for (let index = 0; index < length; index++) {
        const element = childModels[index];
        if ([UIModelType.MULTIPLY, UIModelType.GROUP].includes(element.type)) {
            return checkChildModelSomeWith(element, callback);
        }
        if (callback(element)) {
            return true;
        }
    }
    return false;
};


